<div [ngClass]="{'overlay': showModal, 'show-overlay': showModal}"></div>
<div *ngIf="showModal" class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <!-- Contenido del modal -->
            <div class="modal-header">
                <h5 class="modal-title">Detalle del periodo</h5>
                <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <!-- Inicia Formulario  -->
                <form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
                    <div style="text-align: right; padding-bottom: 2px;">
                        <i title="Limpiar los campos!" class="fa fa-eraser icono-limpiar" aria-hidden="true"
                            style="cursor: pointer; margin-right: 10px;" (click)="cancel()"></i>
                    </div>

                    <div class="form-group row">

                        <div class="textOnInput col-4 col-md-12 col-sm-12">
                            <label class="form-label" for="inputText">Periodo</label>
                            <input class="form-control form-input" type="text" formControlName="period"
                                autocomplete="off" [class.is-invalid]="campoNoValido('period')" placeholder="Ejm. 2025"
                                title="Representa el espacio de tiempo para el que se hizo el levantamiento de información">
                            <small class="text-danger" *ngIf="campoNoValido('period')">Este campo es
                                requerido</small>
                        </div>
                        <div class="textOnInput col-2 col-md-6 col-sm-12">
                            <label class="form-label" for="inputText">Cota incial Xi</label>
                            <input class="form-control form-input" type="number" formControlName="xi" autocomplete="off"
                                [class.is-invalid]="campoNoValido('xi')"
                                title="Cotas del eje Probabilidad (Xi/Xf): Estas cotas se refieren a la coordenada en el eje X. Xi representa el punto de inicio del eje X, mientras que Xf representa el punto máximo al que llegará el eje X.">
                            <small class="text-danger" *ngIf="campoNoValido('xi')">Este campo es
                                requerido</small>
                        </div>

                        <div class="textOnInput col-2 col-md-6 col-sm-12">
                            <label class="form-label" for="inputText">Cota final Xf</label>
                            <input class="form-control form-input" type="number" formControlName="xf" autocomplete="off"
                                [class.is-invalid]="campoNoValido('xf')"
                                title="Cotas del eje Probabilidad (Xi/Xf): Estas cotas se refieren a la coordenada en el eje X. Xi representa el punto de inicio del eje X, mientras que Xf representa el punto máximo al que llegará el eje X.">
                            <small class="text-danger" *ngIf="campoNoValido('xf')">Este campo es
                                requerido</small>
                        </div>

                        <div class="textOnInput col-2 col-md-6 col-sm-12">
                            <label class="form-label" for="inputText">Cota inicial Yi</label>
                            <input class="form-control form-input" type="number" formControlName="yi" autocomplete="off"
                                [class.is-invalid]="campoNoValido('yi')"
                                title="Cotas del eje Impacto (Yi/Yf): Estas cotas se refieren a la coordenada en el eje Y. Yi representa el punto de inicio del eje Y, mientras que Yf representa el punto máximo al que llegará el eje Y.">
                            <small class="text-danger" *ngIf="campoNoValido('yi')">Este campo es
                                requerido</small>
                        </div>

                        <div class="textOnInput col-2 col-md-6 col-sm-12">
                            <label class="form-label" for="inputText">Cota final Yf</label>
                            <input class="form-control form-input" type="number" formControlName="yf" autocomplete="off"
                                [class.is-invalid]="campoNoValido('yf')"
                                title="Cotas del eje Impacto (Yi/Yf): Estas cotas se refieren a la coordenada en el eje Y. Yi representa el punto de inicio del eje Y, mientras que Yf representa el punto máximo al que llegará el eje Y.">
                            <small class="text-danger" *ngIf="campoNoValido('yf')">Este campo es
                                requerido</small>
                        </div>

                        <div class="textOnInput col-12">
                            <label class="form-label" for="inputText">Descripción</label>
                            <textarea class="form-control" formControlName="description" autocomplete="off"
                                [class.is-invalid]="campoNoValido('description')" rows="6"
                                title="La descripción sera el texto introductorio que se mostrará al usuario final para cada período."></textarea>
                            <small class="text-danger" *ngIf="campoNoValido('description')">Este campo es
                                requerido</small>
                        </div>

                        <div class="textOnInput col-12">
                            <label class="form-label" for="inputText">Enlace para descargar reporte</label>
                            <input class="form-control form-input" type="text" formControlName="url" autocomplete="off"
                                [class.is-invalid]="campoNoValido('url')"
                                title="El enlace sera el botón que se mostrará al usuario final para descargar el reporte de cada período">
                            <small class="text-danger" *ngIf="campoNoValido('url')">Este campo es
                                requerido</small>
                        </div>

                        <div class="textOnInput col-12">
                            <label class="form-label" for="inputText">Visible/oculto</label>
                            <div class="label-container align-switch">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="switch2"
                                        formControlName="status">
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex justify-content-start">
                                <div class="me-2">
                                    <button type="button" class="btn btn-outline-secondary btn-block"
                                        (click)="closeModal()">
                                        Cancelar
                                    </button>
                                </div>
                                <div>
                                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
                <!-- Termina Formulario  -->

                <hr>
                <!-- Incia lista de periodos -->
                <br>
                <div class="col-md-12">
                    <div class="row">
                        <h6>Lista de periodos</h6>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-detail text-center table-success">
                                    <tr>
                                        <th scope="col">N°</th>
                                        <th scope="col">Periodo</th>
                                        <th scope="col">Descripcion</th>
                                        <th scope="col">Xi</th>
                                        <th scope="col">Xf</th>
                                        <th scope="col">Yi</th>
                                        <th scope="col">Yf</th>
                                        <th scope="col">Estado</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="tbody-detail" *ngFor="let obj of listPeriods; let i = index">
                                        <td>{{ i + 1 }}</td>
                                        <td class="text-center">{{ obj.period }}</td>
                                        <td class="text-center">{{ obj.description?.substring(0, 20) }}</td>
                                        <td class="text-center">{{ obj.xi }}</td>
                                        <td class="text-center">{{ obj.xf }}</td>
                                        <td class="text-center">{{ obj.yi }}</td>
                                        <td class="text-center">{{ obj.yf }}</td>
                                        <td class="text-center">
                                            <div class="label-active" *ngIf="obj.status">ACTIVO</div>
                                            <div class="label-inactive" *ngIf="!obj.status">INACTIVO</div>
                                        </td>
                                        <td class="text-center">
                                            <a class="a-icon" (click)="editScatterPeriod(obj)"><i
                                                    class="fa fa-pencil i-icon"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Termina lista de periodos -->
            </div>

        </div>
    </div>
</div>